interface LeagueNameProps {
  name: string;
}

export default function LeagueName({ name }: LeagueNameProps) {
  return (
    <span className="max-w-[146px] text-center overflow-hidden text-ellipsis line-clamp-2 font-robotoMedium font-medium text-[12px] leading-[16px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
      {name}
    </span>
  );
}
